module.exports = __webpack_public_path__ + "img/image_8.87779f71.jpg";